import picoapp from 'picoapp'

import header from './components/header.js'
import product from './components/product.js'
import cartDrawer from './components/cartDrawer.js'
import cartDrawerItem from './components/cartDrawerItem.js'
import accountLogin from './components/accountLogin.js'
import inlineVideo from './components/inlineVideo.js'
import press from './components/press.js'
import promobar from './components/promobar.js'
import faqs from './pages/faqs.js'
// import productSelection from './components/productSelection.js'

const state = {
  cartOpen: false
}

const actions = {
  toggleCart: open => state => ({ cartOpen: !state.cartOpen })
}

const components = {
  header,
  product,
  cartDrawer,
  cartDrawerItem,
  inlineVideo,
  accountLogin,
  press,
  promobar,
  faqs,

}

export default picoapp(components, state, actions)
